import React from "react";
import "./Why_Online_MBA.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleXmark,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import CommonHeading from "../../common-component/common-heading/CommonHeading";

const comparisonData = [
  {
    feature: "Founder/CXO Masterclasses",
    atlas: "check",
    traditional: "cross",
  },
  {
    feature: "Real Business Case Studies",
    atlas: "check",
    traditional: "cross",
  },
  {
    feature: "1:1 Mentor Support",
    atlas: "check",
    traditional: "cross",
  },
  {
    feature: "Campus Immersion",
    atlas: "check",
    traditional: "warning",
  },
  {
    feature: "Placement Support",
    atlas: "check",
    traditional: "warning",
  },
  {
    feature: "Corporate Mentorship Sessions",
    atlas: "check",
    traditional: "warning",
  },
  {
    feature: "Industry Recognition",
    atlas: "check",
    traditional: "warning",
  },
  {
    feature: "AI-Integrated Curriculum",
    atlas: "check",
    traditional: "cross",
  },
  {
    feature: "International Pro Access",
    atlas: "check",
    traditional: "cross",
  },
  {
    feature: "Global Faculty",
    atlas: "check",
    traditional: "warning",
  },
  {
    feature: "Global Immersion",
    atlas: "check",
    traditional: "warning",
  },
];

const StatusIcon = ({ type }) => {
  if (type === "check") {
    return (
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="comparison_status comparison_check"
      />
    );
  }

  if (type === "cross") {
    return (
      <FontAwesomeIcon
        icon={faCircleXmark}
        className="comparison_status comparison_cross"
      />
    );
  }

  return (
    <FontAwesomeIcon
      icon={faTriangleExclamation}
      className="comparison_status comparison_warning"
    />
  );
};

const Why_Online_MBA = () => {
  return (
    <section className="why_online_mba">
      <div className="container">
        {/* Heading */}
        {/* <div className="why_online_mba_heading">
          <div className="why_online_small_title">Why Online</div>

          <h2>
            MBA <span>Stands Out</span>
          </h2>

          <p>
            We've reimagined online business education around AI, real-world
            business, and the corporate skills that make you future-ready.
          </p>
        </div> */}

        <CommonHeading
          subTitle={"Why Online"}
          title={"MBA Stands Out"}
          description={
            " We've reimagined online business education around AI, real-world business, and the corporate skills that make you future-ready."
          }
        />

        {/* Comparison Table */}
        <div className="comparison_wrapper">
          <div className="comparison_table">
            {/* Header */}
            <div className="comparison_row comparison_header_row">
              <div className="comparison_feature_header"></div>

              <div className="comparison_column_header atlas_header">
                ATLAS Online MBA
              </div>

              <div className="comparison_column_header traditional_header">
                Traditional Online MBA
              </div>
            </div>

            {/* Rows */}
            {comparisonData.map((item, index) => (
              <div className="comparison_row" key={index}>
                <div className="comparison_feature">{item.feature}</div>

                <div className="comparison_value atlas_value">
                  <StatusIcon type={item.atlas} />
                </div>

                <div className="comparison_value traditional_value">
                  <StatusIcon type={item.traditional} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Apply Button */}
        <div className="comparison_button_wrapper">
          <button className="comparison_apply_btn">Apply Now</button>
        </div>
      </div>
    </section>
  );
};

export default Why_Online_MBA;
